import { FaRegPlusSquare, FaChalkboardTeacher,FaUserGraduate  } from "react-icons/fa";
import { BiTransfer } from "react-icons/bi";
import { GrSecure, GrUserSettings } from "react-icons/gr";

const iconStyle = (Icon) => <Icon />

//used to control the name of kinship
export const kinship = ["SON", "DAUGHTER", "RELATIVE", "FRIEND"]
//

//used to return the avatar of a photo (need to be removed)
export const default_avatar = (img, w, h) => (
  <img
    src={process.env.PUBLIC_URL + `/assets/images/avatars/${img}.png`}
    width={w}
    height={h}
  />
)

//used to control the names of days
export const daysWeek = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
]
//

//used to control the type of acccount on system
export const type_of_account={personal:"PERSONAL",parent_kids:"PARENT_KIDS",company:"COMPANY",guest:"GUEST",personal_manually:"PERSONAL_MANUALLY"}
//

//used to control the type of attachments
export const attachment_type = {
  ID_file:"ID_FILE",
  avatar:"AVATAR",
  profile:"PROFILE",
  course:"COURSE",
  class:"CLASS",
  workshop:"WORKSHOP",
  student:"STUDENT",
  teacher: "TEACHER",
  assignment: "ASSIGNMENT"
}
//

//used to control the type of classes used
export const type_of_classes={
  Class:"NormalClass",
  Workshop:"Workshop"
}
//

//used to control the type of folder on uploads
export const type_of_uploads ={
  "Images": "Images",
  "Files": "Files"
}
export const firebase_folders={
  "Courses": "Courses",
  "Classes": "Classes",
  "Workshops": "Workshops",
  "Students": "Students",
  "Teachers": "Teachers",
  "Assignments": "Assignments"
}
//

//used to control the type of files
export const MIM_types_of_images=[
  "image/svg+xml",
  "image/png",
  "image/jpeg"
]
export const MIM_types_of_files=[
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/pdf",
  "text/html",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
  "text/plain",
  "application/zip",
  "application/x-7z-compressed",
  "application/x-tar",
  "text/javascript",
  "application/json"
]
//

//used to set the type of how control students
export const classesStudentsTypes = {
  'addStudents' : 'Add Student',
  'transferStudents' : 'Transfer Students'
}

export const studenstClassesButtons=[
  {
    label: classesStudentsTypes.addStudents,
    icon: iconStyle(FaRegPlusSquare),
  },
  {
    label: classesStudentsTypes.transferStudents,
    icon: iconStyle(BiTransfer),
  },
]
//

//used to set the tools when i want to trasnfer students
export const type_of_transfer_students_ddl = [
  {
    id: "STUDENTS_PROGRESS",
    value: "Student progress"
  },
  {
    id: "CHANGE_SECTION",
    value: "Change section"
  }
]
export const type_of_transfer_students = 
{
    STUDENTS_PROGRESS: "STUDENTS_PROGRESS",
    CHANGE_SECTION: "CHANGE_SECTION"
}
//

//used to set the types of payments mdoes
export const type_of_payments_modes = 
{
  TRANSFER_MONEY: "Trasnfer Money",
  CASH_MONEY: "Cash Money",
  CREDIT_CARD: "Credit Card",
}

//used to set the type of users payments
export const paymentsType = {
  'students' : 'Students',
  'teachers' : 'Teachers'
}
export const paymentsButtons=[
  {
    label: paymentsType.students,
    icon: iconStyle(FaUserGraduate),
  },
  {
    label: paymentsType.teachers,
    icon: iconStyle(FaChalkboardTeacher),
  },
]
//

//used to set the categories of payments page
export const permissionsRolesType = {
  'createPermission' : 'Create Permission',
  'viewAllPermissions': 'View Permissions',
  'createRole': 'Create Role',
  'viewAllRoles': 'View Roles'
}
export const permissionsOrRolesButtons=[
  {
    label: permissionsRolesType.createPermission,
    icon: iconStyle(GrSecure),
    roles: "ADMIN"
  },
  {
    label: permissionsRolesType.viewAllPermissions,
    icon: iconStyle(GrSecure),
    roles: "ADMIN"
  },
  {
    label: permissionsRolesType.createRole,
    icon: iconStyle(GrUserSettings),
    roles: "ALL"
  },
  {
    label: permissionsRolesType.viewAllRoles,
    icon: iconStyle(GrUserSettings),
    roles: "ALL"
  },
]
//

//used to control the CRUD in permissions page
export const permissionsOrRolesButtonsType = {
  'control_role_permissions': 'Control Role Permissions',
  'edit_normal': 'Edit Normal',
  'delete_normal': 'Delete Normal'
}
//

//used to display errors
export const errors_messages = {
  err1 : "Unexpected error occurred!, please check the data."
}
//

//used to control the types of permissions available on system
export const permissions_type = {
  "VIEW_TEACHERS" : "View Teachers", //
  "CREATE_STUDENT": "Create Student",
  "UPDATE_STUDENT": "Update Student",
  "DELETE_STUDENT": "Delete Student",
  "CREATE_TEACHER": "Create Teacher",
  "UPDATE_TEACHER": "Update Teacher",
  "DELETE_TEACHER": "Delete Teacher",
  "VIEW_COURSES" : "View Courses", //
  "CREATE_COURSE": "Create Course",
  "UPDDATE_COURSE": "Update Course",
  "DELETE_COURSE": "Delete Course",
  "VIEW_CLASSES" : "View Classes", //
  "CREATE_CLASS": "Create Class",
  "UPDATE_CLASS": "Update Class",
  "DELETE_CLASS": "Delete Class",
  "VIEW_WORKSHOPS" : "View Workshops", //
  "CREATE_WORKSHOP": "Create Workshop",
  "UPDATE_WORKSHOP": "Update Workshop",
  "DELETE_WORKSHOP": "Delete Workshop",
  "VIEW_SCHEDULED_COURSE" : "View Scheduled Courses", //
  "CREATE_SCHEDULED_COURSE": "Create Schedueled Course",
  "UPDATE_SCHEDULED_COURSE": "Update Scheduled Course",
  "DELETE_SCHEDULED_COURSE": "Delete Scheduled Course",
  "VIEW_REQUESTS" : "View Requests", //
  "PROCESS_REQUEST": "Proccess Request",
  "VIEW_INVOICES" : "View Invoices", //
  "CREATE_INVOICE": "Create Invoice",
  "UPDATE_INVOICE": "Update Invoice",
  "DELETE_INVOICE": "Delete Invoice",
  "VIEW_ROLES": "View Roles", //
  "CREATE_ROLE": "Create Role",
  "UPDATE_ROLE": "Update Role",
  "DELETE_ROLE": "Delete Role",
  "VIEW_PERMISSIONS" : "View Permissions", //
  "CREATE_PERMISSION": "Create Permission",
  "UPDATE_PERMISSION": "Update Permission",
  "DELETE_PERMISSION": "Delete Permission",
  "ADD_STUDENT_TO_CLASS": "Add Student To Class",
  "TRANSFER_STUDENT_TO_CLASS": "Transfer Student To Class",
  "VIEW_ASSIGNMENTS": "View Assignments",
  "VIEW_ASSIGNMENT": "View Assignment",
  "CREATE_ASSIGNMENT": "Create Assignment", 
  "UPDATE_ASSIGNMENT": "Update Assignment",
  "DELETE_ASSIGNMENT" : "Delete Assignment" 
}

//ROELS OF USERS
export const roles_type = {
  "ADMIN" : "ADMIN",
  "TEACHER": "TEACHER",
  "STUDENT": "STUDENT",
  "PARENT": "PARENT"
}

//Difficulty terms used into assignments
export const difficulty_terms = {
  "EASY" : "Easy",
  "MEDIUM": "Medium",
  "HARD" : "Hard"
}

//Grading system terms
export const grading_system = {
  "LETTERS" : "Letters",
  "POINTS": "Points"
}

export const letters_grades = [
  'A', 'B', 'C', 'D', 'E', 'F'
]